import { Component, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { CategoryDetailsComponent } from '../category-details/category-details.component';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { EnquiryRegService } from 'src/app/services/services/enquiry-reg.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteCategoryDialogComponent } from '../enquiry-registration-dialogs/delete-category-dialog/delete-category-dialog.component';
import { AddNodeDialogComponent } from '../enquiry-registration-dialogs/add-node-dialog/add-node-dialog.component';
import { UnsavedChangesDialogComponent } from '../enquiry-registration-dialogs/unsaved-changes-dialog/unsaved-changes-dialog.component';

@Component({
    selector: 'app-category-list',
    templateUrl: './categories-list.component.html',
    styleUrls: ['./categories-list.component.scss'],
    standalone: false
})


export class CategoriesListComponent implements OnInit {
  filter: string = "";
  isCategorySelected: boolean = false;
  selectedCategory: any;
  mainCategories: any;
  mainCategoriesFiltered: any;
  initialCategories: any[] = [];
  isSaveDisabled: boolean = true;
  isUndoDisabled: boolean = true;
  isSaveCategoryListDisabled: boolean = true;
  isDataLoaded: boolean = false;
  deleteIds = [];

  constructor(private enquiryRegService: EnquiryRegService, private dialog: MatDialog, private i18nextPipe: I18NextPipe) { }

  ngOnInit(): void {
    this.selectedCategory = { categoryId: -1 };
    this.getCategories();
  }

  getCategories(id?) {
    let enqRegApi = this.enquiryRegService.getAllCategories();
    enqRegApi.subscribe(cats => {
      for (let i = 0; i < cats.length; i++) {
        if (cats[i].isDefault && !cats[i].isOutbound) cats[i]["globalSettingType"] = "Default";
        if (!cats[i].isDefault && cats[i].isOutbound) cats[i]["globalSettingType"] = "Dialler";
        if (!cats[i].isDefault && !cats[i].isOutbound) cats[i]["globalSettingType"] = "";
      }
      this.mainCategories = cats;
      this.mainCategoriesFiltered = cats;
      this.initialCategories = cats;
      this.deleteIds = [];
      if (cats.length === 0) {
        this.isCategorySelected = false;
        this.isDataLoaded = true;
      } else {
        if (this.selectedCategory?.categoryId !== -1) {
          if (id) {
            this.selectedCategory = cats.filter(c => c.categoryId === id)[0];
          } else {
            this.selectedCategory = cats[0];
          }
        } else {
          this.selectedCategory = cats[0];
        }

        this.isCategorySelected = true;
        this.isDataLoaded = true;
      }
    });
  }

  addCategory() {
    const dialogRef = this.dialog.open(AddNodeDialogComponent, {
      panelClass: 'dialog-standard-pannel',
      width: "450px",
      height: "180px",
      data: { 
        title: this.i18nextPipe.transform('translation:Add category'), 
        button: this.i18nextPipe.transform('translation:Save')
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        let category = {
          description: data.description,
          isOutbound: false,
          isMultiSelect: false,
          categoryNum: this.mainCategoriesFiltered.length + 1,
          isDefault: false,
          categoryId: -1
        }

        this.enquiryRegService.createCategory(category).subscribe(res => {
          this.getCategories(res);
        })
      }
    });
  }

  saveChanges() {
    this.isDataLoaded = false;
    this.enquiryRegService.updateCategoriesOrder(this.mainCategories).subscribe(cats => {
      this.isSaveCategoryListDisabled = true;
      this.isUndoDisabled = true;
      this.isDataLoaded = true;
    });

    if (this.deleteIds.length > 0) {
      let enqRegApi = this.enquiryRegService.deleteCategory(this.deleteIds);
      enqRegApi.subscribe(cats => {
        this.getCategories();
      });
    }
  }

  undoChanges() {
    this.isSaveCategoryListDisabled = true;
    this.isUndoDisabled = true;
    this.isDataLoaded = false;
    this.deleteIds = [];
    this.getCategories();
  }

  filterCategories() {
    this.mainCategoriesFiltered = this.mainCategories.filter(r => {
      let title = r.description.toLowerCase();
      return (this.filter == "" ? true : (title.includes(this.filter.toLowerCase())))
    });
  }

  selectCategory(category: any) {
    if (!this.isSaveDisabled) {
      const dialogRef = this.dialog.open(UnsavedChangesDialogComponent, {
        panelClass: 'dialog-standard-pannel',
        width: "440px",
        height: "190px"
      });

      dialogRef.afterClosed().subscribe(data => {
        if (data.continue) {
          this.selectedCategory = category;
          this.isCategorySelected = true;
        } else {
        }
      });
    } else {
      this.selectedCategory = category;
      this.isCategorySelected = true;
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    if (this.filter.length > 0) return;

    // Reorder the mainCategories array
    moveItemInArray(this.mainCategories, event.previousIndex, event.currentIndex);
    this.mainCategoriesFiltered = this.mainCategories;

    // Update the categoryNum property based on the new order
    this.mainCategories.forEach((category, index) => {
      category.categoryNum = index + 1;
    });

    this.isUndoDisabled = false;
    this.isSaveCategoryListDisabled = false;
  }

  isSaveDisabledCheck(ev) {
    this.isSaveDisabled = ev;
  }

  deleteCategory(category: any) {
    const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
      panelClass: 'dialog-standard-pannel',
      width: "500px",
      height: "240px",
      data: { id: category.categoryId, description: category.description }
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data && data.id) {
        this.deleteIds.push(category.categoryId);
        let index = this.mainCategories.indexOf(this.mainCategories.find(c => c.categoryId === category.categoryId));
        this.mainCategories.splice(index, 1);

        this.mainCategories.forEach((category, index) => {
          category.categoryNum = index + 1;
        });

        if (this.selectedCategory.categoryId === category.categoryId) {
          this.selectedCategory = this.mainCategories[0];
          if (this.mainCategories.length === 0) {
            this.isCategorySelected = false;
          }
        }

        this.isUndoDisabled = false;
        this.isSaveCategoryListDisabled = false;
      }
    });
  }
}